import { useState } from "react";
import { supabase } from "./supabase";

export default function Auth({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    setLoading(true);
    setMessage("");
    try {
      if (isLogin) {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        onLogin(data.user);
      } else {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setMessage("Compte créé! Vérifiez votre email pour confirmer.");
      }
    } catch (err) {
      setMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <div style={styles.icon}>⚖</div>
        <h1 style={styles.title}>OHADA Expert</h1>
        <p style={styles.sub}>Intelligence Juridique IA · 3 833 décisions CCJA</p>
        <div style={styles.tabs}>
          <button style={{...styles.tab, ...(isLogin?styles.tabOn:{})}} onClick={() => setIsLogin(true)}>Connexion</button>
          <button style={{...styles.tab, ...(!isLogin?styles.tabOn:{})}} onClick={() => setIsLogin(false)}>Inscription</button>
        </div>
        <input
          style={styles.input}
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          style={styles.input}
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSubmit()}
        />
        {message && <div style={styles.message}>{message}</div>}
        <button
          style={{...styles.btn, ...(loading?styles.btnOff:{})}}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "..." : isLogin ? "Se connecter" : "Créer un compte"}
        </button>
        <p style={styles.hint}>
          {isLogin ? "Pas encore de compte ? " : "Déjà un compte ? "}
          <span style={styles.link} onClick={() => setIsLogin(!isLogin)}>
            {isLogin ? "S'inscrire" : "Se connecter"}
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  root:{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",background:"#080d1a"},
  card:{background:"rgba(13,21,40,0.95)",border:"1px solid rgba(201,168,76,0.22)",borderRadius:16,padding:"40px 32px",width:"100%",maxWidth:400,textAlign:"center"},
  icon:{fontSize:"2.5em",color:"#c9a84c",marginBottom:12},
  title:{fontFamily:"Georgia,serif",fontSize:"1.8em",fontWeight:700,color:"#e5d5a5",marginBottom:6},
  sub:{fontSize:"0.72em",color:"#8896b0",marginBottom:24,letterSpacing:"0.04em"},
  tabs:{display:"flex",gap:4,background:"rgba(255,255,255,0.04)",borderRadius:8,padding:4,marginBottom:20},
  tab:{flex:1,background:"none",border:"none",color:"#8896b0",padding:"8px",borderRadius:6,cursor:"pointer",fontSize:"0.85em",fontFamily:"Georgia,serif"},
  tabOn:{background:"rgba(201,168,76,0.15)",color:"#c9a84c"},
  input:{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(201,168,76,0.22)",borderRadius:8,color:"#ddd5c0",padding:"11px 14px",fontSize:"0.88em",fontFamily:"Georgia,serif",outline:"none",marginBottom:12,boxSizing:"border-box"},
  message:{fontSize:"0.8em",color:"#ff9966",marginBottom:12,padding:"8px",background:"rgba(255,100,50,0.1)",borderRadius:6},
  btn:{width:"100%",background:"linear-gradient(135deg,#c9a84c,#9e7830)",border:"none",borderRadius:8,color:"#fff",padding:"12px",fontSize:"0.9em",cursor:"pointer",fontFamily:"Georgia,serif",marginBottom:16},
  btnOff:{opacity:0.5,cursor:"not-allowed"},
  hint:{fontSize:"0.78em",color:"#8896b0"},
  link:{color:"#c9a84c",cursor:"pointer"},
};
